import { TranslateService } from "@ngx-translate/core";

import { DashboardItemType } from "../bfx-common/models/dashboard-item-type.enum";

import {
  GoldenLayoutService,
  GLPopoutConfiguration,
  GLPopoutState,
  GLPopoutUndockBehaviour,
} from "../golden-layout/golden-layout-service";

import { GoldenLayoutAdditionMode } from "../golden-layout/golden-layout-addition-mode";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxOrderCancelComponentLauncher {
  /**
   * Launches a new instance of the order cancelation window
   * @param orders ids of the orders to be cancelled for limits, BmarkOrderData for BMs
   * @param layoutService golden layout service instance
   * @param translationService ngx translation service instance
   */
  public static launch(
    orders: Array<CubiqTS.OrderDataImpl>,
    layoutService: GoldenLayoutService,
    translationService: TranslateService,
    event: any,
  ): void {
    let title: string = translationService.instant("cancel.order.title");

    let config: GLPopoutConfiguration = new GLPopoutConfiguration();

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = true;
    config.preferredSize = {
      width: Math.max(750, window.innerWidth / 2),
      height: 345,
    };
    config.minimumSize = { width: 630, height: 345 };
    config.data = orders;
    config.sourceEvent = event && event.sourceEvent ? event.sourceEvent : event;

    layoutService.launchFromDashboard(
      title,
      DashboardItemType.OrderCancel,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }
}
